module.exports = __webpack_public_path__ + "static/media/can_2.ba07006f.png";